import { render, staticRenderFns } from "./App.vue?vue&type=template&id=02d2c4dd&"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=02d2c4dd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports